import branches from '@/router/routes/entities/branches'
import deliveryZones from '@/router/routes/entities/deliveryZones'
import categories from '@/router/routes/entities/categories'
import collections from '@/router/routes/entities/collections'
import menu from '@/router/routes/entities/menu'
import modifications from '@/router/routes/entities/modifications'
import news from '@/router/routes/entities/news'
import organizations from '@/router/routes/entities/organizations'
import priceLists from '@/router/routes/entities/priceLists'
import promocodes from '@/router/routes/entities/promocodes'
import promotions from '@/router/routes/entities/promotions'
import regions from '@/router/routes/entities/regions'
import slider from '@/router/routes/entities/slider'
import staff from '@/router/routes/entities/staff'
import technicalCards from '@/router/routes/entities/technicalCards'
import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/entities',
    name: RouteName.Directory,
    component: () => import('@/pages/EntitiesPage.vue'),
    meta: {
      permissions: [CRMPermission.ViewEntities],
      breadcrumb: {
        label: 'Справочник',
        parent: 'Главная',
      },
    },
  },
  ...branches,
  ...deliveryZones,
  ...categories,
  ...collections,
  ...menu,
  ...modifications,
  ...news,
  ...organizations,
  ...priceLists,
  ...promocodes,
  ...promotions,
  ...regions,
  ...slider,
  ...staff,
  ...technicalCards,
]
